/**
 * Returns a formatted string for a Date, format MM/DD/YYYY.
 */
const formatDateString = (date?: Date | string) => {
  if (typeof date === 'string') return date;

  return date && date.toLocaleDateString
    ? date.toLocaleDateString('es-pa')
    : undefined;
};

export { formatDateString };
